/**
 * A competition habit was logged or un-logged on this page (namat#36): the
 * results card re-reads its standings, as mobile's TodayScreen does after
 * every toggle. Plain in-memory listeners — the loggers and the card live in
 * the same tab, and nothing here needs the DOM.
 */
type Listener = (competitionId: string) => void;

const listeners = new Set<Listener>();

export function notifyCompetitionLogChanged(competitionId: string): void {
  listeners.forEach((listener) => {
    try {
      listener(competitionId);
    } catch (error) {
      console.error('competition log listener failed:', error);
    }
  });
}

/** Returns the unsubscribe function, ready for a useEffect cleanup. */
export function onCompetitionLogChanged(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
